<script lang="ts" setup>
import BasicButton from '~/components/form-elements/BasicButton.vue'
import { useBodyOverflowControl } from '~/composables/use-body-overflow-control'
import constants from '~/constants'
import helpers from '~/helpers'
import { useSearchboosterStore } from '~/store/searchbooster'

const props = defineProps<{
  isBack: boolean
  title: string
}>()

const emit = defineEmits<{
  (e: 'back'): void
}>()

const isPopupVisible = ref(false)

const totalProducts = computed<number>(() => searchboosterStore.searchMeta?.hits || 0)

const bodyOverflowControl = useBodyOverflowControl()
const searchboosterStore = useSearchboosterStore()
const { isSearchLoading } = storeToRefs(searchboosterStore)

function cancel (): void {
  bodyOverflowControl.enable()
  closePopup()
}

function closePopup (): void {
  isPopupVisible.value = false
}

function openPopup (): void {
  isPopupVisible.value = true

  bodyOverflowControl.disable()
}

function onClickButtonHandler (): void {
  if (props.isBack) {
    emit('back')
  } else {
    bodyOverflowControl.enable()
    closePopup()
  }
}

defineExpose({ closePopup, openPopup })
</script>

<template>
  <div v-if="isPopupVisible" class="fixed inset-0 z-[9999] size-full bg-main-gray-low">
    <div class="flex h-[calc(100%-min(15vh,72px))] flex-col justify-between">
      <div>
        <div class="flex items-center justify-between px-2 py-3">
          <div class="w-16">
            <a v-if="isBack" href="#" @click.prevent="emit('back')">
              <SvgIcon class="!size-6" name="outlined/arrow-back" />
            </a>
          </div>

          <div class="text-sm font-medium tracking-[-0.01em] text-main-dark">
            {{ title }}
          </div>

          <div class="w-[64.16px]">
            <a
              v-if="!isBack"
              class="text-sm font-medium tracking-[-0.01em] !text-main-green !no-underline"
              href="#"
              @click.prevent="cancel"
            >
              Отменить
            </a>
          </div>
        </div>

        <div class="mt-0 flex flex-col px-2 md:mt-6">
          <slot />
        </div>
      </div>

      <BasicButton
        class="mx-2 !h-14 !w-auto !rounded-2xl !text-base"
        color="green"
        :is-loading="isSearchLoading"
        is-small
        :title="isBack
          ? 'Применить'
          : `Показать ${totalProducts} ${helpers.getDeclension(totalProducts, constants.wordForms.product)}`
        "
        @click="onClickButtonHandler"
      />
    </div>
  </div>
</template>
